import { FunnelStatuses, Search } from 'features/co-pilot/co-pilot.types';
import { Edge, Node } from 'reactflow';

export interface FunnelOverview {
  _id: string;
  updatedAt: string;
  createDate: string;
  name: string;
  status: FunnelStatuses;
  linkedinAccount: string;
  approveMessages: boolean;
  toBeApprovedMessages: number;
  /** Kontakte, die vor der ersten Ansprache auf Freigabe warten (settings.approveContacts). */
  toBeApprovedContacts?: number;
  funnelSummary: FunnelSummary;
  isCompleted: boolean;
  workedLastFor: number;
  searches?: Search[];
  lastUpdate?: {
    updatedAt: string;
    updatedBy: string;
  };
  /** Editorial plan: campaign auto-launches at this time. */
  scheduledStartAt?: string;
  /** Stand des Assistenten „Neue Kampagne“; nur Kampagnen, die dort entstanden sind, haben ihn. */
  wizard?: Record<string, unknown> | null;
  /** True when this campaign was automatically paused due to a LinkedIn account lock. */
  pausedByAccountLock?: boolean;
}

export interface FunnelSummary {
  // minus deleted, blacklisted, suspended or test contacts
  totalContactsCount: number; // # of contacts in the funnel
  activeContactsCount: number; // # of contacts that are active
  sentConnectionRequestsCount: number; // # of connection requests sent
  acceptedConnectionRequestsCount: number; // # of connection requests accepted
  contactedContactsCount: number; // # of contacts that have been contacted (connection requests or messages)
  replyAndAcceptCount: number; // # of contacts that have replied to a message or accepted a connection request
  messageReplyCount: number; // # of contacts that have replied via text message
  positiveReplyCount: number; // # of positive replies (text replies with a positive sentiment)
  negativeReplyCount: number; // # of negative replies (text replies with a negative sentiment)
  finishedContactsCount: number; // # of contacts that have been finished
  connectedContactsCount: number; // # of contacts that have been or are already connected via LinkedIn
  /** Kontaktvorrat: aktive Kontakte in Schritt 0, noch nicht angeschrieben. */
  unsentContactsCount?: number;
  /** Noch nicht geladene Treffer in offenen Suchen (0 = keine oder unbekannt). */
  searchContactsRemaining?: number;
  /** Kommt aus den Suchen noch etwas nach, ist alles geladen, oder gibt es keine Suchen? */
  contactSupply?: ContactSupplyState;
}

export type ContactSupplyState = 'more' | 'exhausted' | 'none';

export enum StatisticsAccordionStates {
  FUNNEL = 'funnel',
  MESSAGE_HISTORY = 'message-history',
  CONVERSIONS = 'conversions',
}

export interface FunnelData {
  nodes: Node[];
  edges: Edge[];
  steps: any[];
}
